import { useMemo } from 'react'
import { useContextCosign } from '../components/useContextCosign'
import { wordPressHost } from '../utils/location'
import { getRegisterOrLoginRedirectUrl } from '../utils/wordPressRoute'

export function useRedirectUrl() {
  const { routeMap, environment } = useContextCosign()

  const [redirectUrl, validateUrl] = useMemo(() => {
    { /* 獲取來源頁面，並進行安全檢查 */ }
    const getReferrerUrl = () => {
      const referrer = document.referrer
      const currentOrigin = window.location.origin
      const defaultRedirectUrl = '/my-account/edit-account/'

      { /* 如果沒有 referrer，返回默認頁面路徑 */ }
      if (!referrer) {
        return defaultRedirectUrl
      }

      try {
        const referrerUrl = new URL(referrer)

        { /* 確保 referrer 來自同一個網站 */ }
        if (referrerUrl.origin !== currentOrigin) {
          return defaultRedirectUrl
        }

        { /* 避免重定向到 bind 相關頁面（防止循環） */ }
        if (referrerUrl.pathname.includes('/bind-phone')
          || referrerUrl.pathname.includes('/bind-email')) {
          return defaultRedirectUrl
        }

        { /* 返回來源頁面的完整路徑 */ }
        return referrerUrl.pathname + referrerUrl.search
      }
      catch (e) {
        { /* URL 解析失敗，返回默認頁面 */ }
        console.warn('Failed to parse referrer URL:', e)
        return defaultRedirectUrl
      }
    }

    const dynamicBindPath = getReferrerUrl()

    if (environment === 'merchant') {
      return [{
        registerOrLogin: `${window.location.origin}${routeMap?.merchant}`,
        bind: `${window.location.origin}${routeMap?.merchant}/edit-account/`,
        forgetPassword: `${window.location.origin}/password/reset/?no-cache`,
      }, {
        registerOrLogin: `${window.location.origin}${routeMap?.merchant}/?validate=registerOrLogin`,
        bind: `${window.location.origin}/bind-email/`,
        forgetPassword: `${window.location.origin}${routeMap?.merchant}/?validate=forgetPassword`,
      }]
    }

    if (environment === 'campaign') {
      return [{
        registerOrLogin: `${window.location.origin}${routeMap?.campaign}`,
        bind: `${window.location.origin}${routeMap?.campaign}/edit-account/`,
        forgetPassword: `${window.location.origin}/password/reset/?no-cache`,
      }, {
        registerOrLogin: `${window.location.origin}${routeMap?.campaign}/?validate=registerOrLogin`,
        bind: `${window.location.origin}/bind-email/`,
        forgetPassword: `${window.location.origin}${routeMap?.campaign}/?validate=forgetPassword`,
      }]
    }

    return [{
      registerOrLogin: getRegisterOrLoginRedirectUrl(),
      bind: `${window.location.origin}${dynamicBindPath}`,
      forgetPassword: `${wordPressHost}/password/reset/?no-cache`,
    }, {
      registerOrLogin: `${wordPressHost}/my-account/?validate=registerOrLogin`,
      bind: `${wordPressHost}/bind-email/`,
      forgetPassword: `${wordPressHost}/my-account/?validate=forgetPassword`,
    }]
  }, [environment, routeMap?.campaign, routeMap?.merchant])

  return { redirectUrl, validateUrl }
}
